module.exports = __webpack_public_path__ + "ea60340a9622485f4de05cfb8bd79e6c.svg";